export enum INDUSTRY {
  ACCOUNTANCY = 'Accountancy',
  AGRICULTURE = 'Agriculture',
  ANTIQUES = 'Antiques',
  ARCHAEOLOGY = 'Archaeology',
  ARCHITECTURE = 'Architecture',
  ARTISTRY = 'Artistry',
  AUCTIONEERING = 'Auctioneering',
  AUTOMOTIVE = 'Automotive',
  CATERING = 'Catering',
  CHARITY = 'Charity',
  CIVIL_SERVICE = 'CivilService',
  CLERICAL_SERVICES = 'ClericalServices',
  CONSTRUCTION = 'Construction',
  CONSULTANCY = 'Consultancy',
  COSMETICS_HAIR_AND_BEAUTY = 'CosmeticsHairAndBeauty',
  CULINARY_SERVICES = 'CulinaryServices',
  CUSTOMER_SERVICES = 'CustomerServices',
  DENTISTRY = 'Dentistry',
  DIPLOMACY = 'Diplomacy',
  DRIVING_OTHER = 'DrivingOther',
  DRIVING_TAXI = 'DrivingTaxi',
  EDUCATIONAL_SERVICES = 'EducationalServices',
  EMERGENCY_SERVICES = 'EmergencyServices',
  ENGINEERING = 'Engineering',
  ENTERTAINMENT = 'Entertainment',
  FINANCIAL_SERVICES = 'FinancialServices',
  FISHING = 'Fishing',
  FORESTRY = 'Forestry',
  FUNERAL_CARE = 'FuneralCare',
  GAMBLING = 'Gambling',
  HEALTHCARE_AND_MEDICINE = 'HealthcareAndMedicine',
  HOSPITALITY_AND_TOURISM = 'HospitalityAndTourism',
  INSURANCE = 'Insurance',
  IT_AND_COMMUNICATIONS = 'ITAndCommunications',
  LAUNDRY = 'Laundry',
  LAW = 'Law',
  LAW_ENFORCEMENT = 'LawEnforcement',
  LOGISTICS = 'Logistics',
  LUXURY_SALES = 'LuxurySales',
  MANAGEMENT = 'Management',
  MANUFACTURING = 'Manufacturing',
  MARITIME = 'Maritime',
  MARKETING = 'Marketing',
  MECHANICS = 'Mechanics',
  MILITARY_SERVICES = 'MilitaryServices',
  MINING_AND_EXTRACTION = 'MiningAndExtraction',
  OTHER_INDUSTRY = 'OtherIndustry',
  PAINTING_AND_DECORATION = 'PaintingAndDecoration',
  PAWNBROKING = 'Pawnbroking',
  PLUMBING = 'Plumbing',
  POLITICS = 'Politics',
  PROPERTY = 'Property',
  PUBLICAN_SERVICES = 'PublicanServices',
  RELIGION = 'Religion',
  RETAIL = 'Retail',
  SALES = 'Sales',
  SCIENCE_AND_RESEARCH = 'ScienceAndResearch',
  SOCIAL_CARE = 'SocialCare',
  SPORTS_AND_ATHLETICS = 'SportsAndAthletics',
  STORAGE = 'Storage',
  TELECOMMUNICATIONS = 'Telecommunications',
  TELESALES = 'Telesales',
  TRADE_SERVICES = 'TradeServices',
  TRAVEL_AND_TOURISM = 'TravelAndTourism',
  UTILITIES = 'Utilities',
  VETERINARY_SERVICES = 'VeterinaryServices',
  WASTE_MANAGEMENT = 'WasteManagement',
}
